// League system utilities — no Supabase dependency, pure functions

export const LEAGUE_TIERS = [
  { id: 1,  name: "Bronze",   bg: "bg-amber-700",   text: "text-amber-100",  border: "border-amber-600",  emoji: "🥉" },
  { id: 2,  name: "Silver",   bg: "bg-gray-400",    text: "text-gray-900",   border: "border-gray-300",   emoji: "🥈" },
  { id: 3,  name: "Gold",     bg: "bg-yellow-400",  text: "text-yellow-900", border: "border-yellow-300", emoji: "🥇" },
  { id: 4,  name: "Sapphire", bg: "bg-blue-600",    text: "text-blue-100",   border: "border-blue-400",   emoji: "💎" },
  { id: 5,  name: "Ruby",     bg: "bg-rose-600",    text: "text-rose-100",   border: "border-rose-400",   emoji: "♦️"  },
  { id: 6,  name: "Emerald",  bg: "bg-emerald-500", text: "text-emerald-100",border: "border-emerald-300",emoji: "💚" },
  { id: 7,  name: "Amethyst", bg: "bg-purple-500",  text: "text-purple-100", border: "border-purple-300", emoji: "🔮" },
  { id: 8,  name: "Pearl",    bg: "bg-stone-300",   text: "text-stone-800",  border: "border-stone-200",  emoji: "🪩" },
  { id: 9,  name: "Obsidian", bg: "bg-zinc-800",    text: "text-zinc-100",   border: "border-zinc-600",   emoji: "⚫" },
  { id: 10, name: "Diamond",  bg: "bg-cyan-300",    text: "text-cyan-900",   border: "border-cyan-200",   emoji: "💠" },
];

export const PROMOTION_SLOTS = 10;
export const DEMOTION_SLOTS  = 5;
export const GROUP_BUCKETS   = 200;

// djb2 string hash — deterministic, no external deps
function djb2Hash(str) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
    hash = hash & 0x7fffffff; // keep positive 31-bit
  }
  return hash;
}

// Returns the most recent Monday as "YYYY-MM-DD"
export function getMondayISO() {
  const now = new Date();
  const day = now.getDay(); // 0=Sun, 1=Mon …
  const diff = day === 0 ? -6 : 1 - day;
  const monday = new Date(now);
  monday.setDate(now.getDate() + diff);
  monday.setHours(0, 0, 0, 0);
  return monday.toISOString().split("T")[0];
}

// Returns a short week key, e.g. "2026-W08"
export function getWeekKey(mondayISO) {
  const d = new Date(mondayISO + "T00:00:00");
  const startOfYear = new Date(d.getFullYear(), 0, 1);
  const weekNum = Math.ceil(
    ((d - startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
  );
  return `${d.getFullYear()}-W${String(weekNum).padStart(2, "0")}`;
}

// Deterministic group bucket (0 … GROUP_BUCKETS-1)
export function assignGroupId(userId, weekKey, tier) {
  return djb2Hash(`${userId}|${weekKey}|${tier}`) % GROUP_BUCKETS;
}

// True if stored Monday date is not the current Monday
export function needsWeeklyReset(storedMondayISO) {
  return storedMondayISO !== getMondayISO();
}

// Momentum score: weekly XP boosted by streak
export function calcMomentum(weeklyXP, streak) {
  return Math.round((weeklyXP || 0) * (1 + (streak || 0) / 10));
}

// Returns +1 (promote), -1 (demote), or 0, with small-group guards
export function getLeagueChange(rank, groupSize, currentTier) {
  if (groupSize < 6) return 0; // too small to rank fairly
  const promoSlots = Math.min(PROMOTION_SLOTS, Math.floor(groupSize * 0.33));
  const demoSlots  = Math.min(DEMOTION_SLOTS,  Math.floor(groupSize * 0.17));
  if (rank <= promoSlots && currentTier < 10) return +1;
  if (rank > groupSize - demoSlots && currentTier > 1) return -1;
  return 0;
}
